import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Daundtotrimbkeshwarbusonrent() {



  const cardData =
  {
    keyword: 'Daund to Trimbakeshwar Bus On Rent',
    heading: 'Sanavi Travels: Daund to Trimbakeshwar Bus On Rent',
    headingDescription: 'Sanavi Travels offers reliable Daund to Trimbakeshwar Bus On Rent, providing safe, comfortable, and convenient transportation for pilgrims, families, groups, and corporate travelers visiting the holy Trimbakeshwar temple. Our fleet of well-maintained AC and non-AC buses ensures spacious seating, smooth rides, and ample luggage space for a hassle-free journey. With professional drivers, flexible one-way and round-trip rental packages, transparent pricing, and 24/7 booking support, Sanavi Travels guarantees punctual, dependable, and stress-free travel. We provide convenient pickup and drop services across Daund, Pune, and nearby areas, making it ideal for religious trips, group travel, family outings, and corporate tours. Choose Sanavi Travels for trusted Daund to Trimbakeshwar bus rental services, delivering comfort, safety, and a seamless travel experience for every occasion.',

    top: 'Top Places to Visit in Trimbakeshwar with Sanavi Travels',


"topPlaces": [
  {
    "title": "Trimbakeshwar Temple",
    "description": "Trimbakeshwar Temple is a sacred Hindu shrine dedicated to Lord Shiva, known for its Jyotirlinga. The temple’s intricate architecture and spiritual significance make it a major pilgrimage site, attracting devotees throughout the year."
  },
  {
    "title": "Godavari Source (Brahmagiri Hills)",
    "description": "The Brahmagiri Hills near Trimbakeshwar are the source of the sacred Godavari River. Pilgrims often visit this site to perform rituals and enjoy the scenic beauty of the surrounding hills and forests."
  },
  {
    "title": "Kapaleshwar Temple",
    "description": "Kapaleshwar Temple is another important Shiva temple near Trimbakeshwar, offering spiritual solace and a glimpse into traditional temple architecture. It is frequented by devotees and tourists alike."
  },
  {
    "title": "Trimbakeshwar Panchvati",
    "description": "Panchvati in Trimbakeshwar is a sacred area associated with rituals and religious ceremonies. Pilgrims visit this site for holy dips and spiritual practices linked to Lord Shiva."
  },
  {
    "title": "Anjaneri Hills",
    "description": "Anjaneri Hills, located near Trimbakeshwar, are believed to be the birthplace of Lord Hanuman. The hills offer trekking opportunities, panoramic views, and spiritual significance for visitors."
  },
  {
    "title": "Raja Dinkar Kelkar Museum (Trimbak Branch)",
    "description": "A small branch or display area associated with cultural artifacts may be visited here, showcasing local heritage and the region’s history alongside the spiritual journey."
  },
  {
    "title": "Trimbakeshwar Local Markets",
    "description": "The markets around Trimbakeshwar offer religious items, souvenirs, local handicrafts, and prasads. These bustling markets provide a glimpse into the local culture and traditions."
  },
  {
    "title": "Historic Temples Nearby",
    "description": "Several smaller temples and shrines surround Trimbakeshwar, offering pilgrims additional sites for worship and exploration of the spiritual landscape."
  },
  {
    "title": "Natural Springs and Waterfalls",
    "description": "The region around Trimbakeshwar is dotted with natural springs and small waterfalls, providing serene spots for meditation, relaxation, and nature walks."
  },
  {
    "title": "Trekking Routes and Scenic Trails",
    "description": "Trimbakeshwar is surrounded by scenic trails and trekking paths in the Sahyadri ranges, ideal for adventure seekers and nature enthusiasts visiting the area."
  }
]
,



"services": [
    {
      "name": "Daund to Trimbakeshwar Bus On Rent",
      "description": "Daund to Trimbakeshwar Bus On Rent offers reliable and comfortable transportation for pilgrims, families, and groups traveling from Daund to Trimbakeshwar. With spacious seating, well-maintained buses, and professional drivers, it ensures a safe and smooth journey to the holy Jyotirlinga temple."
    },
    {
      "name": "Trimbakeshwar Bus from Daund",
      "description": "Trimbakeshwar Bus from Daund provides flexible bus rental options for religious tours, family trips, and group excursions. With experienced drivers and modern buses, it ensures a hassle-free travel experience for those visiting Trimbakeshwar from Daund."
    },
    {
      "name": "AC Bus Daund to Trimbakeshwar",
      "description": "AC Bus Daund to Trimbakeshwar offers air-conditioned buses for a comfortable and refreshing travel experience. Perfect for long-distance religious trips and family journeys, it combines comfort, safety, and reliability throughout the route."
    },
    {
      "name": "Jyotirlinga Darshan Bus",
      "description": "Jyotirlinga Darshan Bus provides dedicated transportation for pilgrims visiting Trimbakeshwar. Equipped with comfortable seating, safety features, and professional drivers, it ensures a seamless, convenient, and memorable pilgrimage experience."
    },
    {
      "name": "Religious Tour Bus Daund",
      "description": "Religious Tour Bus Daund caters to spiritual travelers and groups visiting Trimbakeshwar and nearby temples. With organized itineraries, reliable buses, and chauffeur-driven service, it offers an efficient and peaceful journey for devotees."
    },
    {
      "name": "Family Bus Trimbakeshwar",
      "description": "Family Bus Trimbakeshwar is ideal for family trips from Daund to Trimbakeshwar. Spacious seating, entertainment options, and experienced drivers make the journey safe, comfortable, and enjoyable for all family members."
    },
    {
      "name": "Group Travel Bus Trimbakeshwar",
      "description": "Group Travel Bus Trimbakeshwar provides organized and convenient transportation for friends, corporate groups, and social groups visiting the Trimbakeshwar temple. Comfortable buses and professional drivers ensure a hassle-free group travel experience."
    },
    {
      "name": "Affordable Bus Trimbakeshwar",
      "description": "Affordable Bus Trimbakeshwar offers cost-effective bus rental services for religious trips, family tours, and group travel. Despite budget-friendly pricing, it maintains high standards of safety, comfort, and reliability."
    },
    {
      "name": "Chauffeur Driven Bus Trimbakeshwar",
      "description": "Chauffeur Driven Bus Trimbakeshwar provides a stress-free travel experience with professional drivers managing navigation, traffic, and schedules. Ideal for families, groups, and pilgrims, ensuring timely and safe arrivals."
    },
    {
      "name": "Best Bus Daund to Trimbakeshwar",
      "description": "Best Bus Daund to Trimbakeshwar guarantees top-quality buses, punctual service, and experienced drivers. Perfect for family trips, group pilgrimages, and religious tours, it ensures a smooth, comfortable, and enjoyable journey."
    },
    {
      "name": "Pilgrimage Bus Rental",
      "description": "Pilgrimage Bus Rental provides dedicated transportation for religious tours and temple visits. With reliable buses, professional drivers, and organized itineraries, it ensures a convenient, safe, and memorable spiritual journey."
    },
    {
      "name": "Tourist Bus Trimbakeshwar",
      "description": "Tourist Bus Trimbakeshwar caters to sightseeing and short trips to Trimbakeshwar and nearby attractions. Comfortable buses, flexible schedules, and experienced drivers make it ideal for tourists and family travelers."
    },
    {
      "name": "Online Bus Booking Daund",
      "description": "Online Bus Booking Daund allows easy reservation of buses from Daund to Trimbakeshwar. With instant confirmation, multiple bus options, and flexible itineraries, it simplifies planning for family trips, religious tours, and group travel."
    },
    {
      "name": "Temple Tour Bus",
      "description": "Temple Tour Bus provides organized transport for visiting Trimbakeshwar and surrounding temples. Spacious buses, professional drivers, and safety measures ensure pilgrims and tourists have a smooth and memorable journey."
    },
    {
      "name": "Daund Travel Bus",
      "description": "Daund Travel Bus offers reliable transportation services for local, outstation, and religious travel. Combining affordability, comfort, and safety, it is perfect for families, corporate groups, tourists, and pilgrims traveling to Trimbakeshwar."
    }
  ],
  "tableData": [
    ["Daund to Trimbakeshwar Bus On Rent", "Trimbakeshwar Bus from Daund"],
    ["AC Bus Daund to Trimbakeshwar", "Jyotirlinga Darshan Bus"],
    ["Religious Tour Bus Daund", "Family Bus Trimbakeshwar"],
    ["Group Travel Bus Trimbakeshwar", "Affordable Bus Trimbakeshwar"],
    ["Chauffeur Driven Bus Trimbakeshwar", "Best Bus Daund to Trimbakeshwar"],
    ["Pilgrimage Bus Rental", "Tourist Bus Trimbakeshwar"],
    ["Online Bus Booking Daund", "Temple Tour Bus"],
    ["Daund Travel Bus", "—"]
  ]
,



"whychoose": [
  {
    "WhyChooseheading": "Daund to Trimbakeshwar Bus on Rent with Sanavi Travels",
    "WhyChoosedescription": "Sanavi Travels offers reliable and comfortable bus rental services from Daund to Trimbakeshwar, ideal for pilgrimages, group outings, corporate trips, and family tours."
  },
  {
    "WhyChooseheading": "Spacious and Well-Maintained Buses",
    "WhyChoosedescription": "Our buses are clean, air-conditioned, and regularly serviced, ensuring a smooth and comfortable journey for your group from Daund to Trimbakeshwar."
  },
  {
    "WhyChooseheading": "Experienced and Professional Drivers",
    "WhyChoosedescription": "Our licensed drivers are familiar with the Daund to Trimbakeshwar route, ensuring safe, timely, and smooth travel for your group."
  },
  {
    "WhyChooseheading": "Transparent Pricing with No Hidden Charges",
    "WhyChoosedescription": "Sanavi Travels provides clear and upfront pricing for Daund to Trimbakeshwar bus rentals, including fuel, tolls, and driver allowances, with no hidden charges."
  },
  {
    "WhyChooseheading": "24/7 Customer Support",
    "WhyChoosedescription": "Our customer support team is available around the clock to assist with bookings, travel queries, and itinerary planning for your Daund to Trimbakeshwar bus rental."
  },
  {
    "WhyChooseheading": "Flexible Rental Options",
    "WhyChoosedescription": "Choose from hourly, half-day, full-day, or customized rental packages based on your group’s schedule and travel requirements."
  },
  {
    "WhyChooseheading": "Safe and Sanitized Vehicles",
    "WhyChoosedescription": "All buses are thoroughly cleaned and sanitized before every trip to ensure a safe and hygienic travel experience for your group."
  },
  {
    "WhyChooseheading": "Reliable and On-Time Service",
    "WhyChoosedescription": "We guarantee punctual pickups and dependable service, making Sanavi Travels a trusted choice for Daund to Trimbakeshwar bus rentals."
  }
]

}

const faqData = [
  {
    question: 'Does Sanavi Travels provide bus rental services from Daund to Trimbakeshwar?',
    answer: 'Yes, Sanavi Travels offers reliable bus rental services for travel from Daund to Trimbakeshwar for pilgrimages, family tours, and group outings.'
  },
  {
    question: 'How can I book a bus from Daund to Trimbakeshwar?',
    answer: 'You can easily book a bus through our website or by contacting our 24x7 customer support team.'
  },
  {
    question: 'What types of buses are available for rental from Daund to Trimbakeshwar?',
    answer: 'Sanavi Travels provides a variety of buses including mini buses, 20-seater, 32-seater, 45-seater, and 50-seater options for your journey from Daund to Trimbakeshwar.'
  },
  {
    question: 'Are the drivers experienced with the Daund to Trimbakeshwar route?',
    answer: 'Yes, our drivers are licensed, professional, and familiar with the Daund to Trimbakeshwar route, ensuring safe and timely travel.'
  },
  {
    question: 'Can I choose custom pickup and drop-off locations?',
    answer: 'Absolutely. You can select your preferred pickup location in Daund and drop-off in Trimbakeshwar.'
  },
  {
    question: 'Is the bus service from Daund to Trimbakeshwar available 24x7?',
    answer: 'Yes, Sanavi Travels provides round-the-clock bus services from Daund to Trimbakeshwar to accommodate your travel schedule.'
  },
  {
    question: 'Are the buses sanitized before every trip?',
    answer: 'Yes, all buses are thoroughly cleaned and sanitized before departure to ensure a safe and hygienic experience for your group.'
  },
  {
    question: 'What payment options are available for bus rentals?',
    answer: 'We accept UPI, credit/debit cards, digital wallets, bank transfers, and corporate payments for your bus rental bookings.'
  },
  {
    question: 'Is customer support available during the journey?',
    answer: 'Yes, our 24x7 customer support team is available throughout your Daund to Trimbakeshwar bus trip.'
  }
];

const testimonials = [
  {
    id: 1,
    name: 'Mr. Manoj Patil',
    feedback: 'Rented a bus for our pilgrimage trip from Daund to Trimbakeshwar. Comfortable ride, professional driver, and excellent service.',
    rating: 5
  },
  {
    id: 2,
    name: 'Ms. Aarti Kulkarni',
    feedback: 'Sanavi Travels made our Daund to Trimbakeshwar journey smooth and stress-free. Highly recommend their bus rental service.',
    rating: 5
  }
];



































































































































  const Images = [
    { place: "/images/keyword/1.jpg", text: "Tempo Traveller On Rent in Pune", link: "tempo-traveller-on-rent-in-pune" },
    { place: "/images/keyword/2.jpg", text: "Pune to Shirdi Tempo Traveller On Rent", link: "pune-to-shirdi-tempo-traveller-on-rent" },
    { place: "/images/keyword/3.jpg", text: "Pune to Mahabaleshwar Tempo Traveller on Rent", link: "pune-to-mahabaleshwar-tempo-traveller-on-rent" },
    { place: "/images/keyword/4.jpg", text: "Pune to Goa Tempo Traveller Hire", link: "pune-to-goa-tempo-traveller-hire" },
    { place: "/images/keyword/5.jpg", text: "Pune to Mumbai Tempo Traveller on Rent", link: "pune-to-mumbai-tempo-traveller-on-rent" },
    { place: "/images/keyword/6.jpg", text: "Pune to Konkan Darshan Tempo Traveller Hire", link: "pune-to-konkan-darshan-tempo-traveller-hire" },
    { place: "/images/keyword/7.jpg", text: "Pune to Nashik Tempo Traveller On Rent", link: "pune-to-nashik-tempo-traveller-on-rent" },
    { place: "/images/keyword/8.jpg", text: "Tempo Traveller On Rent for Pune Darshan", link: "tempo-traveller-on-rent-for-pune-darshan" },
    { place: "/images/keyword/9.jpg", text: "Mini Bus On Rent in Pune", link: "mini-bus-on-rent-in-pune" },
    { place: "/images/keyword/10.jpg", text: "13 Seater Tempo Traveller On Rent in Pune", link: "13-seater-tempo-traveller-on-rent-in-pune" },
    { place: "/images/keyword/11.jpg", text: "17 Seater Tempo Traveller on Rent in Pune", link: "17-seater-tempo-traveller-on-rent-in-pune" },
    { place: "/images/keyword/12.jpg", text: "20 Seater Luxury Bus On Rent Pune", link: "20-seater-luxury-bus-on-rent-pune" },
    { place: "/images/keyword/13.jpg", text: "26 Seater Tempo Traveller On Rent in Pune", link: "26-seater-tempo-traveller-on-rent-in-pune" },
    { place: "/images/keyword/14.jpg", text: "32 Seater Luxury Bus On Rent in Pune", link: "32-seater-luxury-bus-on-rent-in-pune" },
    { place: "/images/keyword/15.jpg", text: "35 Seater Bus on Rent in Pune", link: "35-seater-bus-on-rent-in-pune" },
    { place: "/images/keyword/16.jpg", text: "45 Seater Bus On Rent in Pune", link: "45-seater-bus-on-rent-in-pune" },
    { place: "/images/keyword/17.jpg", text: "50 Seater Bus On Rent in Pune", link: "50-seater-bus-on-rent-in-pune" },
    { place: "/images/keyword/18.jpg", text: "Bus Hire for School Trips in Pune", link: "bus-hire-for-school-trips-in-pune" },
    { place: "/images/keyword/19.jpg", text: "Bus booking for Wedding in Pune", link: "bus-booking-for-wedding-in-pune" },
    { place: "/images/keyword/20.jpg", text: "Bus Booking for Marriage in Pune", link: "bus-booking-for-marriage-in-pune" },
    { place: "/images/keyword/21.jpg", text: "Bus Service for Corporate in Pune", link: "bus-service-for-corporate-in-pune" },
    { place: "/images/keyword/22.jpg", text: "Bus on Rent For Event in Pune", link: "bus-on-rent-for-event-in-pune" },
    { place: "/images/keyword/23.jpg", text: "Bus Hire for Outstation in Pune", link: "bus-hire-for-outstation-in-pune" },
    { place: "/images/keyword/24.jpg", text: "AC Bus On Rent in Pune", link: "ac-bus-on-rent-in-pune" },
    { place: "/images/keyword/25.jpg", text: "Pune Bus Hire Rental Service", link: "pune-bus-hire-rental-service" },
  ];











const jsonData = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Daund to Trimbakeshwar Bus On Rent - Sanavi Travels",
  "description": "Sanavi Travels offers AC and luxury buses on rent from Daund to Trimbakeshwar for family trips, group tours, and religious Jyotirlinga pilgrimages. Affordable chauffeur-driven buses with online booking options.",
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.9",
    "ratingCount": "60"
  }
};





  return (
    <div>
<Helmet>
  <title>
    Daund to Trimbakeshwar Bus On Rent | Sanavi Travels
  </title>

  <meta
    name="description"
    content="Sanavi Travels offers AC and luxury buses on rent from Daund to Trimbakeshwar for family trips, group tours, and religious Jyotirlinga pilgrimages. Affordable chauffeur-driven buses with online booking options."
  />

  <script type="application/ld+json">
    {JSON.stringify(jsonData)}
  </script>
</Helmet>

      <div className="page-headder bg-section parallaxie">
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <div className="page-header-box text-white">
                <h1 className="text-anime-style-3 text-center text-white" data-cursor="-opaque">
                  <h3> {cardData.keyword}</h3>
                </h1>
              </div>
            </div>
          </div>
        </div>
      </div>





      <section>
        <div className="container-fluid" >
          <div className="row container-fluid p-0">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/122.jpg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#183765', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                <p className="sectionLead">{cardData.top}</p>

                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>
                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>



              <div className="shambhu-services">
                {cardData.services.map((service, index) => (
                  <div key={index} className="sh-service-card">

                    <div className="sh-service-left">
                      <div className="sh-service-icon">
                        🚖
                      </div>
                    </div>

                    <div className="sh-service-content">
                      <h4 className="sh-service-title">{service.name}</h4>
                      <p className="sh-service-desc">{service.description}</p>
                    </div>

                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable />

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Sanavi Travels </span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Sanavi Travels </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title="Frequently Asked"
                          subtitle="Help & Info"
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
                <h4 className="pc-title">Contact Information</h4>

                <div className="pc-grid">
                  {/* Phones */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-telephone-fill"></i>
                      <span>Phone Numbers</span>
                    </header>

                    <div className="pc-list">
                      <a href="tel:+917387507373" className="pc-call">+91 7387507373</a>
                      <a href="tel:+919595532929" className="pc-call">+91 9595532929</a>
                    </div>

                    <div className="pc-cta">
                      <a
                        href="https://wa.me/917387507373"
                        target="_blank" rel="noopener noreferrer"
                        className="pc-whats"
                      >
                        <i className="bi bi-whatsapp me-1"></i> WhatsApp
                      </a>
                      <a href="tel:+917387507373" className="pc-primary">
                        Call Now
                      </a>
                    </div>
                  </section>

                  {/* Email */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-envelope-fill"></i>
                      <span>Email</span>
                    </header>

                    <a href="mailto:booking@sanavitravels.com" className="pc-email">
                      booking@sanavitravels.com
                    </a>
                  </section>

                  {/* Address */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-house-fill"></i>
                      <span>Address</span>
                    </header>

                    <address className="pc-address">
                      <strong>Sanavi Travels</strong><br />
                      OFFICE NO.6, GROUND FLOOR GAT NO.1110,
                      SHREE GOPINATH MAHARAJ VYAPARI SHED SHIVAJI CHOWK, VARVAND TAL DAUND,
                      DIST PUNE – 412215
                    </address>
                  </section>
                </div>
              </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Daundtotrimbkeshwarbusonrent;